import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { CheckCircle, Error } from "@mui/icons-material";
import GeneralLoading from "../../../shared-components/Loading";

const AnswerStatus = ({ answer, notSubmitted = false }) => {
  const theme = useTheme();
  const statusLower = (answer?.status || "").toLowerCase();

  // Base wrapper to align icon/spinner and text
  const Row = ({ children }) => (
    <Box display="flex" alignItems="flex-start">
      {children}
    </Box>
  );

  if (notSubmitted) {
    return (
      <Row>
        <Error sx={{ mr: 1, color: theme.palette.warning.main }} />
        <Typography>Not Submitted</Typography>
      </Row>
    );
  }

  if (statusLower === "marked") {
    return (
      <Row>
        <CheckCircle
          sx={{ mr: 1, color: `${theme.palette.highlight} !important` }}
        />
        {answer.percentage !== null && answer.percentage !== undefined ? (
          <Typography>Marked: {answer.percentage}%</Typography>
        ) : (
          <Typography>Marked</Typography>
        )}
      </Row>
    );
  }

  if (statusLower === "pending") {
    return (
      <Row>
        <GeneralLoading
          direction="row"
          size={25}
          message="Pending..."
          sx={{ mr: 1 }}
        />
      </Row>
    );
  }

  if (statusLower === "being marked" || statusLower === "being_marked") {
    return (
      <Row>
        <GeneralLoading
          direction="row"
          size={25}
          message="Marking..."
          sx={{ mr: 1 }}
        />
      </Row>
    );
  }

  if (statusLower === "extracting text" || statusLower === "extracting_text") {
    return (
      <Row>
        <GeneralLoading
          direction="row"
          size={25}
          message="Extracting Text..."
          sx={{ mr: 1 }}
        />
      </Row>
    );
  }

  if (
    statusLower === "extraction_failed" ||
    answer.status === "Extraction Failed"
  ) {
    return (
      <Row>
        <Error sx={{ mr: 1, color: theme.palette.error.main }} />
        <Typography color={theme.palette.error.main}>
          Extraction Failed
        </Typography>
      </Row>
    );
  }

  return (
    <Row>
      <Error sx={{ mr: 1, color: theme.palette.warning.main }} />
      <Typography>Not Marked</Typography>
    </Row>
  );
};

export { AnswerStatus };
